import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import CameraRetroIcon from "@rsuite/icons/legacy/CameraRetro";
import { toast } from "react-toastify";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";

const PartnerEdit = () => {
  const { id } = useParams();
  const [switchTap, setSwitchTap] = useState(0);
  const usernameRef = useRef(null);
  const last_nameRef = useRef(null);
  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const ccodeRef = useRef(null);
  const roleRef = useRef(null);
  const mobileRef = useRef(null);
  const statusRef = useRef(null);
  const [role, setRole] = useState();
  const [inputs, setInputs] = useState({});
  const [errors, setErrors] = useState({});
  const [fileName, setFileName] = useState(null);
  const [status, setStatus] = useState(["Pending", "Approve", "Reject"]);
  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [numberValue, setNumberValue] = useState("");
  const [country, setCountry] = useState([]);
  console.log("country", country);
  const navigate = useNavigate();
  let defaultvalue = "";
  const access_token = localStorage.getItem("access_token");
  const headers = {
    "Content-Type": "application/json", Authorization: "Bearer " + access_token,
    Accept: "application/json", "Access-Control-Allow-Origin": "*",
  };

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((prevState) => {
      return { ...prevState, [name]: value };
    });
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };
  const handleAccountInputChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((prevState) => {
      return { ...prevState, [name]: value };
    });
  };
  const handleInputChange = (e) => {
    const input = e.target.value;
    const name = e.target.name;
    const sanitizedInput = input.replace(/\D/g, "").slice(0, 10);
    setInputs((prevState) => {
      return { ...prevState, [name]: sanitizedInput };
    });
    if (input.length == 10) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };


  const fetchEdit = () => {
    axios
      .get(
        `${process.env.REACT_APP_Baseurl}/admin/partner/edit/${id}`,
        { headers: headers }
      )
      .then((response) => {
        var result = response?.data?.data;
        setInputs(result?.partnerUser);
        setRole([result?.roles]);
        setCountry(result?.countryCodes)
      })
      .catch((error) => {
        console.error("Error fetching data from the  API:", error);
      });
  };
  useEffect(async () => {
    fetchEdit();
  }, []);
  const handleUpdate = async (e) => {
    e.preventDefault();
    let updatePartnerStatus = false;
    const newErrors = {};
    var pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!inputs?.email) {
      newErrors.email = "Email is required";
      emailRef.current.focus();
    } else {
      if (!pattern.test(inputs?.email)) {
        newErrors.email = "Invaild Email Address";
        emailRef.current.focus();
      }
    }
    if (!inputs?.username) {
      newErrors.username = "Username is required";
      usernameRef.current.focus();
    }
    if (inputs?.mobile?.length === 1) {
      newErrors.mobile = "Enter a valid number max 10 digits";
      mobileRef.current.focus();
    }
    else if (
      inputs?.mobile.length > 1 &&
      inputs?.mobile.length <= 9
    ) {
      newErrors.mobile = "Enter a valid number max 10 digits";
      mobileRef.current.focus();
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      try {
        setProcessing(true);
        setShowOverlay(true);
        const updateData = {
          username: inputs?.username,
          email: inputs?.email,
          mobile: inputs?.mobile,
          last_name: inputs?.last_name,
          ccode: inputs?.ccode,
          user_role: inputs?.user_role,
          commission_percentage: inputs?.commission_percentage,
          status: inputs?.status,
        };
        const response = await axios.post(
          `${process.env.REACT_APP_Baseurl}/admin/partner/update/${id}`,
          updateData,
          { headers }
        );
        const result = response?.data;
        if (result?.status) {
          updatePartnerStatus = true;
          navigate("/partner-index")
        }
        if (updatePartnerStatus) {
          toast.success(result.message);
          setProcessing(false);
          setShowOverlay(false);
        }
      } catch (err) {
        console.error(err);
        var errorMessage = err.response.data.message;
        toast.error(errorMessage);
        setProcessing(false);
        setShowOverlay(false);
      }
    }
  };
  const handleAccountUpdate = async (e) => {
    e.preventDefault();
    let updatePartnerStatus = false;
    try {
      setProcessing(true);
      setShowOverlay(true);
      const updateData = {
        username: inputs?.username,
        last_name: inputs?.last_name,
        ccode: inputs?.ccode,
        email: inputs?.email,
        mobile: inputs?.mobile,
        commission_percentage: inputs?.commission_percentage,
        user_role: inputs?.user_role,
        bank_name: inputs?.bank_name,
        branch_name: inputs?.branch_name,
        account_number: inputs?.account_number,
        IFSC_Code: inputs?.IFSC_Code,
        upi_id: inputs?.upi_id,
        upi_mobile_number: inputs?.upi_mobile_number,
      };
      const response = await axios.post(
        `${process.env.REACT_APP_Baseurl}/admin/partner/update/${id}`, updateData,
        { headers: headers });
      const result = response?.data;
      if (result?.status) {
        updatePartnerStatus = true;
        window.location.reload();
      }
      if (updatePartnerStatus) {
        toast.success(result.message);
        setProcessing(false);
        setShowOverlay(false);
      }
    } catch (err) {
      console.error(err);
      var errorMessage = err?.response?.data?.message || 'An error occurred';
      toast.error({ status: false, message: errorMessage });
      setProcessing(false);
      setShowOverlay(false);
    }
  };
  return (
    <div>
      <div>{showOverlay && <Response_Processing></Response_Processing>}</div>
      <div className=" m-0 p-0">
        <div className="">
          <section className="section container-fluid pt-3">
            <div className="iq-card p-2 mt-3">
              <div className="p-3">
                <h4>
                  <i className="entypo-archive"></i> Update Partner Details
                </h4>
                <hr />
                <div className="d-flex  gap-5 mb-5">
                  <button className={`tabHeading p-0   ${switchTap === 0 && "active"}`} onClick={() => { setSwitchTap(0); }} >
                    Update
                  </button>
                  <button className={` tabHeading p-0 ${switchTap === 1 && "active"}`} onClick={() => { setSwitchTap(1); }} >
                    Account
                  </button>
                </div>
                {switchTap === 0 ? (
                  <form onSubmit={handleUpdate} autoComplete="off" key={"1"}>
                    <div className="row">
                      {/* User Name */}
                      <div className="col-md-6 mb-3 position-relative">
                        <MessageLabel text={"User Name"} className="mandatorySimple" />
                        <input id="name" type="text" className="form-control" name="username" autoComplete="username" value={inputs?.username} onChange={handleChange} ref={usernameRef} />
                        {errors.username && <span className="text-danger" style={{ marginTop: "5px", display: "block" }}>{errors.username}</span>}
                      </div>

                      {/* Last Name */}
                      <div className="col-md-6 mb-3">
                        <MessageLabel text={"Last Name"} className="mandatorySimple" />
                        <input id="last_name" type="text" className="form-control" name="last_name" autoComplete="last_name" value={inputs?.last_name} onChange={handleChange} ref={last_nameRef} />
                        {errors.last_name && <span className="text-danger" style={{ marginTop: "5px", display: "block" }}>{errors.last_name}</span>}
                      </div>

                      {/* Email */}
                      <div className="col-md-6 mb-3">
                        <MessageLabel text={"Email Address"} className="mandatorySimple" />
                        <input id="email" type="email" className="form-control" name="email" autoComplete="email" value={inputs?.email} onChange={handleChange} ref={emailRef} />
                        {errors.email && <span className="text-danger" style={{ marginTop: "5px", display: "block" }}>{errors.email}</span>}
                      </div>

                      {/* Country Code & Mobile Number */}
                      <div className="col-md-6 mb-3">
                        <MessageLabel text={"User's Mobile"} className="mandatorySimple" />
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="col-4">
                            <select name="ccode" value={inputs?.ccode} onChange={handleChange} className="form-select mb-3 custom-placeholder   border border-1 theme-border-color  theme-text-color" ref={ccodeRef}>
                              <option value='0' className="theme-bg-color theme-text-color" >Select Code</option>
                              {country?.map((item, index) => {
                                return <option value={item?.phonecode} className="theme-bg-color theme-text-color">{item?.country_name}-({item?.phonecode})</option>
                              })}
                            </select>

                          </div>
                          <div className="col-8 ms-2">
                            <input type="number" name="mobile" value={inputs?.mobile} onChange={handleInputChange} placeholder="Enter Mobile number" ref={mobileRef} className="rs-input py-3 px-3 custom-placeholder theme-text-color border border-1 theme-border-color  mb-3" />
                            {errors.mobile && <span className="text-danger" style={{ marginTop: "5px", display: "block" }}>{errors.mobile}</span>}
                          </div>
                        </div>
                      </div>


                      {/* User Role */}
                      <div className="col-md-6 mb-3">
                        <MessageLabel text={"User Role"} className="mandatorySimple" />
                        <select className="form-select" name="user_role" onChange={handleChange} value={inputs?.user_role} ref={roleRef}>
                          <option value="0">Select Role</option>
                          {role?.map((roles, index) => (
                            <option key={index} value={roles.id}>{roles.role_name}</option>
                          ))}
                        </select>
                        {errors.user_role && <span className="text-danger" style={{ marginTop: "5px", display: "block" }}>{errors.user_role}</span>}
                      </div>

                      <div className="col-md-6 mb-3">
                        <MessageLabel text={"Approve/Reject"} className="mandatorySimple" />
                        <select
                          className="form-control"
                          id="status"
                          name="status"
                          onChange={handleChange}
                          ref={statusRef}
                        >
                          <option value="">Select an option</option>

                          {status?.map((status, index) => {
                            defaultvalue = inputs?.status === index && status;
                            return (
                              <option
                                key={status}
                                value={index}
                                selected={defaultvalue}
                              >
                                {status}
                              </option>
                            );
                          })}
                        </select>
                        {errors?.status && (
                          <span className="errorred errorredspan p-0">
                            {errors?.status}
                          </span>
                        )}
                      </div>
                    </div>

                    <hr />

                    <div className="row mt-3">
                      <div className="col-sm-12 text-end">
                        <input
                          type="submit"
                          value="Update"
                          className="btn btn-primary "
                        />
                      </div>
                    </div>
                  </form>
                ) : (
                  <form
                    onSubmit={handleAccountUpdate}
                    autoComplete="off"
                    key={"2"}
                  >
                    <div className="row">
                      <div className="col-md-6 mb-4 position-relative pb-2">
                        <MessageLabel text={"Bank Name"} className="mandatorySimple" />
                        <input
                          type="text"
                          id="bank_name"
                          name="bank_name"
                          autoComplete="bank_name"
                          value={inputs?.bank_name}
                          className="form-control "
                          placeholder="Bank Name"
                          onChange={handleAccountInputChange}
                        />
                      </div>
                      <div className="col-md-6 mb-4 position-relative pb-2">
                        <MessageLabel text={"Branch Name"} className="mandatorySimple" />
                        <input
                          type="text"
                          id="branch_name"
                          name="branch_name"
                          value={inputs?.branch_name}
                          className="form-control"
                          autoComplete="branch_name"
                          placeholder="Branch Name"
                          onChange={handleAccountInputChange}
                        />
                      </div>
                      <div className="col-md-6 mb-4 position-relative pb-2 ">
                        <MessageLabel text={" Account Number"} className="mandatorySimple" />
                        <input
                          type="text"
                          id="account_number"
                          name="account_number"
                          value={inputs?.account_number}
                          className="form-control"
                          autoComplete="account_number"
                          placeholder="Account Number"
                          onChange={handleAccountInputChange}
                        />
                      </div>
                      <div className="col-md-6 mb-4 position-relative pb-2">

                        <MessageLabel text={"IFSC Code"} className="mandatorySimple" />
                        <input
                          type="text"
                          id="IFSC_Code"
                          name="IFSC_Code"
                          value={inputs?.IFSC_Code}
                          className="form-control"
                          autoComplete="IFSC_Code"
                          placeholder="IFSC Code"
                          onChange={handleAccountInputChange}
                        />
                      </div>

                      <div className="col-md-6 mb-4 position-relative pb-2">
                        <MessageLabel text={"UPI ID"} className="mandatorySimple" />
                        <input
                          type="text"
                          id="upi_id"
                          name="upi_id"
                          value={inputs?.upi_id}
                          autoComplete="upi_id"
                          className="form-control"
                          placeholder="UPI Id"
                          onChange={handleAccountInputChange}
                        />
                      </div>
                      <div className="col-md-6 mb-4 position-relative pb-2">
                        <MessageLabel text={"UPI Mobile Number"} className="mandatorySimple" />
                        <input type="text" id="upi_mobile_number"
                          name="upi_mobile_number" value={inputs?.upi_mobile_number} className="form-control"
                          placeholder="UPI Mobile Number" autoComplete="upi_mobile_number" onChange={handleAccountInputChange} />
                      </div>
                    </div>{" "}
                    <hr />
                    <div className="row mt-3">
                      <div className="col-sm-12 text-end">
                        <input type="submit" value="Update" className="btn btn-primary" />
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PartnerEdit;